import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import type { Entity, ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ExtractBlogDescriptionFromUrl($projectId: ID!, $url: String!) {
    extractBlogDescriptionFromUrl(projectId: $projectId, url: $url) {
      id
    }
  }
`;

interface Params {
  projectId: ID;
  url: string;
}

export const extractBlogDescriptionFromURL = async ({ projectId, url }: Params) => {
  const variables = {
    url,
    projectId,
  };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });

  return getSingleProp<Entity>(result.data);
};
